import React from "react";
import PropTypes from "prop-types";

const DashboardMetricCard = ({ icon, label, value, context }) => (
    <div className="dashboard-metric-card">
        <div className="dashboard-metric-label">
            {icon}
            <span>{label}</span>
        </div>
        <div className="dashboard-metric-value">{value}</div>
        {context && <div className="dashboard-metric-context">{context}</div>}
    </div>
);

DashboardMetricCard.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    context: PropTypes.string
};

DashboardMetricCard.defaultProps = {
    context: ""
};

export default DashboardMetricCard;
